/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';

export type SvuOwnerDocsSendCloseDataToDmvsPartialUpdateRequest = {} | null | undefined;
export type SvuOwnerDocsSendCloseDataToDmvsPartialUpdateResponse = any;

export type SvuOwnerDocsSendCloseDataToDmvsPartialUpdateQuery = {
  /**
   * ```yaml
   * in: path
   * name: id
   * schema:
   *   type: integer
   * description: A unique integer value identifying this doc.
   * required: true
   * ```
   */
  id?: number;
};

/**
 * PATCH /dmx-server/svu_owner_docs/{id}/send_close_data_to_dmvs/
 *
 * ```yaml
 * operationId: svu_owner_docs_send_close_data_to_dmvs_partial_update
 * tags:
 *   - svu_owner_docs
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     description: No response body
 * ```
 */
export const svuOwnerDocsSendCloseDataToDmvsPartialUpdateOperation = ({
  id,
  ...rest
}: SvuOwnerDocsSendCloseDataToDmvsPartialUpdateQuery) =>
  ({
    method: 'PATCH',
    path: `/dmx-server/svu_owner_docs/${id}/send_close_data_to_dmvs/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'PATCH';
    path: string & { _templateUrl: '/dmx-server/svu_owner_docs/{id}/send_close_data_to_dmvs/' };
  };

/**
 * PATCH /dmx-server/svu_owner_docs/{id}/send_close_data_to_dmvs/
 *
 * ```yaml
 * operationId: svu_owner_docs_send_close_data_to_dmvs_partial_update
 * tags:
 *   - svu_owner_docs
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     description: No response body
 * ```
 */
export const svuOwnerDocsSendCloseDataToDmvsPartialUpdate = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query: SvuOwnerDocsSendCloseDataToDmvsPartialUpdateQuery;
  request?: {} | null;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<any>> => {
  const operation = svuOwnerDocsSendCloseDataToDmvsPartialUpdateOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'PATCH',
    request,
    onUploadProgress,
    cancelToken,
  );
};
